import { z } from 'zod'

/**
 * Zod schema for organization profile form validation
 */
export const organizationProfileFormSchema = z.object({
  // General tab
  legal_name: z
    .string()
    .max(255, 'Legal name must be 255 characters or less')
    .optional()
    .or(z.literal('')),
  tax_id: z
    .string()
    .max(50, 'Tax ID must be 50 characters or less')
    .optional()
    .or(z.literal('')),
  industry: z.string().max(100, 'Industry must be 100 characters or less').optional().or(z.literal('')),
  timezone: z.string().optional().or(z.literal('')),
  currency: z.string().max(3, 'Currency must be 3 characters or less').optional().or(z.literal('')),

  // Branding tab
  logo_url: z
    .string()
    .url('Logo URL must be a valid URL')
    .optional()
    .or(z.literal('')),
  primary_color: z
    .string()
    .regex(/^#[0-9A-F]{6}$/i, 'Primary color must be a valid hex color')
    .optional()
    .or(z.literal('')),

  // Contact tab
  primary_phone: z
    .string()
    .max(20, 'Phone must be 20 characters or less')
    .optional()
    .or(z.literal('')),
  primary_email: z
    .string()
    .email('Primary email must be a valid email')
    .optional()
    .or(z.literal('')),
  website_url: z
    .string()
    .url('Website URL must be a valid URL')
    .optional()
    .or(z.literal('')),

  // Address tab
  address_line1: z
    .string()
    .max(255, 'Address must be 255 characters or less')
    .optional()
    .or(z.literal('')),
  city: z.string().max(100, 'City must be 100 characters or less').optional().or(z.literal('')),
  state_province: z
    .string()
    .max(100, 'State/Province must be 100 characters or less')
    .optional()
    .or(z.literal('')),
  postal_code: z
    .string()
    .max(20, 'Postal code must be 20 characters or less')
    .optional()
    .or(z.literal('')),
  country: z.string().max(100, 'Country must be 100 characters or less').optional().or(z.literal('')),
})

// Input type for form defaultValues
export type OrganizationProfileFormInput = z.input<typeof organizationProfileFormSchema>

// Output type after validation/parsing
export type OrganizationProfileFormValues = z.output<typeof organizationProfileFormSchema>
